// Odkazy na Domů (dlaždice a agenda ranního přehledu, „Otevřít“ u signálu, jména v kartě „Moje lhůty a převzetí“) skládá
// server, ale účet může mít cílovou sekci vypnutou. Rozhodnutí zadavatele 28. 9. 2026 (potvrzeno 2. 10. 2026): kdo
// něco nesmí, ten to nevidí — odkaz do sekce, kterou účet nemá v `ja.sekce`, se proto nevykreslí (vedl by na stránku
// „Nemáte přístup“). Cesty, které nepatří žádné sekci (např. `/`), se nechávají.
import type { Ja } from '@ecoser/shared';
import { klicSekceZCesty } from '../shell/sekce-cesty';

/** Smí účet otevřít cíl odkazu? Bez odkazu nebo bez přihlášeného účtu ne; neznámá cesta (mimo sekce) ano. */
export function smiOtevritOdkaz(
  ja: Ja | null | undefined,
  odkaz: string | null | undefined,
): boolean {
  if (!odkaz || !ja) return false;
  if (!odkaz.startsWith('/')) return true;
  const cesta = odkaz.split(/[?#]/)[0] ?? '';
  const klic = klicSekceZCesty(cesta);
  if (!klic || klic === 'home') return true;
  return (ja.sekce ?? []).includes(klic);
}

/** Kotva karty „Moje lhůty a převzetí“ na Domů (`MojeKarta.tsx`). */
export const ODKAZ_MOJE_KARTA = '/#moje-karta';

/**
 * Odkaz pro tento účet: na vlastní kartu v Zaměstnancích (`/zamestnanci/{já}/…`, např. signál vlastní lhůty) vede
 * účet bez sekce Zaměstnanci na Moje lhůty a převzetí na Domů — skladník a ostatní role sekci nemají (rozhodnutí
 * zadavatele 30. 10. 2026), svoje data ale vidí každý. Jiné odkazy beze změny.
 */
export function odkazProUcet(
  ja: Ja | null | undefined,
  odkaz: string | null | undefined,
): string | null | undefined {
  const jaId = ja?.zamestnanec?.id;
  if (!odkaz || !ja || !jaId) return odkaz;
  const cesta = odkaz.split(/[?#]/)[0] ?? '';
  const vlastni = cesta === `/zamestnanci/${jaId}` || cesta.startsWith(`/zamestnanci/${jaId}/`);
  return vlastni && !(ja.sekce ?? []).includes('zamestnanci') ? ODKAZ_MOJE_KARTA : odkaz;
}
